/**
 * Formats a number into a localized string representation.
 *
 * @param value - The number or string to format.
 * @returns The formatted number as a string.
 */
export const formatNumber = (value?: number | string): string => {
  const userLocale = navigator.language || 'en';
  return new Intl.NumberFormat(userLocale).format(Number(value));
};

export const isNumber = (input: unknown): input is number =>
  typeof input === 'number' && !Number.isNaN(input);

/**
 * Converts a Stripe amount from (euro-)cents to euros/dollars.
 *
 * @param value - Nullable amount in (euro-)cents.
 * @returns The amount in dollars or zero if `value` is not present.
 */
export const convertStripeAmount = (
  value: number | undefined | null,
): number => (value ? value / 100 : 0);
